'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { ContentContainer } from '@module/mdrt-org/shared/components/content-container/content-container';
import { Pagination } from '@module/mdrt-org/shared/components/pagination/pagination';
import { type PublicCustomerProfile } from '@module/mdrt-org/shared/utils/types/public-customer-profile';
import { usePagination } from '@shared/ui-components/pagination/usePagination';
import { type MemberDirectoryProfilePageContent } from '../get-member-directory-profile-page-content';
import styles from './additional-profile-details-section.module.scss';
const PARENT_CLASSNAME = 'additional-profile-details-section';
const extractYearFromISODate = (isoDate: string, locale: string) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric'
  });
  return formatter.format(new Date(isoDate));
};
export const AdditionalProfileDetailsSection = t0 => {
  const $ = _c(121);
  const {
    cmsContent,
    mdrtId,
    publicCustomerProfile
  } = t0;
  const locale = useLocale();
  const {
    memberActivity
  } = publicCustomerProfile || {};
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    currentPage: currentCommitteeDetailsTablePage,
    endIndex,
    setCurrentPage: setCurrentCommitteeDetailsTablePage,
    startIndex
  } = usePagination(t1);
  let t2;
  if ($[1] !== cmsContent.additionalInformationBlock.title) {
    t2 = <h2 className={styles[`${PARENT_CLASSNAME}__heading`]}>{cmsContent.additionalInformationBlock.title}</h2>;
    $[1] = cmsContent.additionalInformationBlock.title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cmsContent.additionalInformationBlock.mdrtIdlabel) {
    t3 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.mdrtIdlabel}</dt>;
    $[3] = cmsContent.additionalInformationBlock.mdrtIdlabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = mdrtId ?? "-";
  let t5;
  if ($[5] !== t4) {
    t5 = <dd className={styles["data-list__value"]}>{t4}</dd>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== cmsContent.additionalInformationBlock.ageLabel) {
    t6 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.ageLabel}</dt>;
    $[7] = cmsContent.additionalInformationBlock.ageLabel;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = publicCustomerProfile?.age ?? "-";
  let t8;
  if ($[9] !== t7) {
    t8 = <dd className={styles["data-list__value"]}>{t7}</dd>;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== cmsContent.additionalInformationBlock.birthdateLabel) {
    t9 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.birthdateLabel}</dt>;
    $[11] = cmsContent.additionalInformationBlock.birthdateLabel;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== locale || $[14] !== publicCustomerProfile) {
    t10 = publicCustomerProfile?.birthday ? extractYearFromISODate(publicCustomerProfile.birthday, locale) : "-";
    $[13] = locale;
    $[14] = publicCustomerProfile;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <dd className={styles["data-list__value"]}>{t10}</dd>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== cmsContent.additionalInformationBlock.firstLastMembershipLabel) {
    t12 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.firstLastMembershipLabel}</dt>;
    $[18] = cmsContent.additionalInformationBlock.firstLastMembershipLabel;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = `${publicCustomerProfile?.firstYear ?? "-"} / ${publicCustomerProfile?.lastYear ?? "-"}`;
  let t14;
  if ($[20] !== t13) {
    t14 = <dd className={styles["data-list__value"]}>{t13}</dd>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== cmsContent.additionalInformationBlock.yearsOfMembershipLevelLabel) {
    t15 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.yearsOfMembershipLevelLabel}</dt>;
    $[22] = cmsContent.additionalInformationBlock.yearsOfMembershipLevelLabel;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const t16 = `${publicCustomerProfile?.totalMembership ?? "-"} / ${publicCustomerProfile?.totalCOT ?? "-"} / ${publicCustomerProfile?.totalTOT ?? "-"}`;
  let t17;
  if ($[24] !== t16) {
    t17 = <dd className={styles["data-list__value"]}>{t16}</dd>;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== cmsContent.additionalInformationBlock.annualMeetingsCountLabel) {
    t18 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.annualMeetingsCountLabel}</dt>;
    $[26] = cmsContent.additionalInformationBlock.annualMeetingsCountLabel;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = `${memberActivity?.totalAnnualMeetingsAttended ?? "-"} / ${memberActivity?.last6AnnualMeetingsAttended ?? "-"}`;
  let t20;
  if ($[28] !== t19) {
    t20 = <dd className={styles["data-list__value"]}>{t19}</dd>;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== cmsContent.additionalInformationBlock.globalConferenceMeetingsCountLabel) {
    t21 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.globalConferenceMeetingsCountLabel}</dt>;
    $[30] = cmsContent.additionalInformationBlock.globalConferenceMeetingsCountLabel;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  const t22 = `${memberActivity?.totalGlobalConferenceMeetingsAttended ?? "-"} / ${memberActivity?.last6GlobalConferenceMeetingsAttended ?? "-"}`;
  let t23;
  if ($[32] !== t22) {
    t23 = <dd className={styles["data-list__value"]}>{t22}</dd>;
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== cmsContent.additionalInformationBlock.mdrtFundationLevelLabel) {
    t24 = <dt className={styles["data-list__label"]}>{cmsContent.additionalInformationBlock.mdrtFundationLevelLabel}</dt>;
    $[34] = cmsContent.additionalInformationBlock.mdrtFundationLevelLabel;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  const t25 = publicCustomerProfile?.donorLevel ?? "-";
  let t26;
  if ($[36] !== t25) {
    t26 = <dd className={styles["data-list__value"]}>{t25}</dd>;
    $[36] = t25;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  let t27;
  if ($[38] !== t11 || $[39] !== t12 || $[40] !== t14 || $[41] !== t15 || $[42] !== t17 || $[43] !== t18 || $[44] !== t20 || $[45] !== t21 || $[46] !== t23 || $[47] !== t24 || $[48] !== t26 || $[49] !== t3 || $[50] !== t5 || $[51] !== t6 || $[52] !== t8 || $[53] !== t9) {
    t27 = <dl className={styles["data-list"]}>{t3}{t5}{t6}{t8}{t9}{t11}{t12}{t14}{t15}{t17}{t18}{t20}{t21}{t23}{t24}{t26}</dl>;
    $[38] = t11;
    $[39] = t12;
    $[40] = t14;
    $[41] = t15;
    $[42] = t17;
    $[43] = t18;
    $[44] = t20;
    $[45] = t21;
    $[46] = t23;
    $[47] = t24;
    $[48] = t26;
    $[49] = t3;
    $[50] = t5;
    $[51] = t6;
    $[52] = t8;
    $[53] = t9;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t2 || $[56] !== t27) {
    t28 = <div className={styles["additional-details"]}>{t2}{t27}</div>;
    $[55] = t2;
    $[56] = t27;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== cmsContent.committeeSummaryTable.title) {
    t29 = <h2 className={styles[`${PARENT_CLASSNAME}__heading`]}>{cmsContent.committeeSummaryTable.title}</h2>;
    $[58] = cmsContent.committeeSummaryTable.title;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <th />;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== cmsContent.committeeSummaryTable.engagementLabel) {
    t31 = <th className="cell--right">{cmsContent.committeeSummaryTable.engagementLabel}</th>;
    $[61] = cmsContent.committeeSummaryTable.engagementLabel;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== cmsContent.committeeSummaryTable.committeeLabel) {
    t32 = <th className="cell--right">{cmsContent.committeeSummaryTable.committeeLabel}</th>;
    $[63] = cmsContent.committeeSummaryTable.committeeLabel;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== cmsContent.committeeSummaryTable.leadershipLabel) {
    t33 = <th className="cell--right">{cmsContent.committeeSummaryTable.leadershipLabel}</th>;
    $[65] = cmsContent.committeeSummaryTable.leadershipLabel;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== t31 || $[68] !== t32 || $[69] !== t33) {
    t34 = <thead className="table__header"><tr>{t30}{t31}{t32}{t33}</tr></thead>;
    $[67] = t31;
    $[68] = t32;
    $[69] = t33;
    $[70] = t34;
  } else {
    t34 = $[70];
  }
  let t35;
  if ($[71] !== cmsContent.committeeSummaryTable.jobsLabel) {
    t35 = <th>{cmsContent.committeeSummaryTable.jobsLabel}</th>;
    $[71] = cmsContent.committeeSummaryTable.jobsLabel;
    $[72] = t35;
  } else {
    t35 = $[72];
  }
  let t36;
  if ($[73] !== cmsContent.committeeSummaryTable.averageLabel) {
    t36 = <th>{cmsContent.committeeSummaryTable.averageLabel}</th>;
    $[73] = cmsContent.committeeSummaryTable.averageLabel;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  let t37;
  if ($[75] !== cmsContent.committeeSummaryTable.totalPointsLabel) {
    t37 = <th>{cmsContent.committeeSummaryTable.totalPointsLabel}</th>;
    $[75] = cmsContent.committeeSummaryTable.totalPointsLabel;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  const t38 = styles[`${PARENT_CLASSNAME}__container-item`];
  const t39 = styles["committee-details"];
  let t40;
  if ($[77] !== cmsContent.committeeDetailsTable.title) {
    t40 = <h2 className={styles[`${PARENT_CLASSNAME}__heading`]}>{cmsContent.committeeDetailsTable.title}</h2>;
    $[77] = cmsContent.committeeDetailsTable.title;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  const t41 = "table-wrapper";
  const t42 = "table";
  let t43;
  if ($[79] !== cmsContent.committeeDetailsTable.yearLabel) {
    t43 = <th>{cmsContent.committeeDetailsTable.yearLabel}</th>;
    $[79] = cmsContent.committeeDetailsTable.yearLabel;
    $[80] = t43;
  } else {
    t43 = $[80];
  }
  let t44;
  if ($[81] !== cmsContent.committeeDetailsTable.divisionLabel) {
    t44 = <th>{cmsContent.committeeDetailsTable.divisionLabel}</th>;
    $[81] = cmsContent.committeeDetailsTable.divisionLabel;
    $[82] = t44;
  } else {
    t44 = $[82];
  }
  let t45;
  if ($[83] !== cmsContent.committeeDetailsTable.committeeLabel) {
    t45 = <th>{cmsContent.committeeDetailsTable.committeeLabel}</th>;
    $[83] = cmsContent.committeeDetailsTable.committeeLabel;
    $[84] = t45;
  } else {
    t45 = $[84];
  }
  let t46;
  if ($[85] !== cmsContent.committeeDetailsTable.roleLabel) {
    t46 = <th>{cmsContent.committeeDetailsTable.roleLabel}</th>;
    $[85] = cmsContent.committeeDetailsTable.roleLabel;
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  let t47;
  if ($[87] !== cmsContent.committeeDetailsTable.pointsPossibleLabel) {
    t47 = <th className="cell--right">{cmsContent.committeeDetailsTable.pointsPossibleLabel}</th>;
    $[87] = cmsContent.committeeDetailsTable.pointsPossibleLabel;
    $[88] = t47;
  } else {
    t47 = $[88];
  }
  let t48;
  if ($[89] !== cmsContent.committeeDetailsTable.pointsEarnedLabel) {
    t48 = <th className="cell--right">{cmsContent.committeeDetailsTable.pointsEarnedLabel}</th>;
    $[89] = cmsContent.committeeDetailsTable.pointsEarnedLabel;
    $[90] = t48;
  } else {
    t48 = $[90];
  }
  let t49;
  if ($[91] !== cmsContent.committeeDetailsTable.finalScoreLabel) {
    t49 = <th className="cell--right">{cmsContent.committeeDetailsTable.finalScoreLabel}</th>;
    $[91] = cmsContent.committeeDetailsTable.finalScoreLabel;
    $[92] = t49;
  } else {
    t49 = $[92];
  }
  let t50;
  if ($[93] !== t43 || $[94] !== t44 || $[95] !== t45 || $[96] !== t46 || $[97] !== t47 || $[98] !== t48 || $[99] !== t49) {
    t50 = <thead className="table__header"><tr>{t43}{t44}{t45}{t46}{t47}{t48}{t49}</tr></thead>;
    $[93] = t43;
    $[94] = t44;
    $[95] = t45;
    $[96] = t46;
    $[97] = t47;
    $[98] = t48;
    $[99] = t49;
    $[100] = t50;
  } else {
    t50 = $[100];
  }
  const t51 = memberActivity?.committeeDetails.slice(startIndex, endIndex).map(_temp);
  let t52;
  if ($[101] !== memberActivity?.committeeDetails.length) {
    t52 = !memberActivity?.committeeDetails?.length && <tr><td>-</td><td>-</td><td>-</td><td>-</td><td className="cell--right">-</td><td className="cell--right">-</td><td className="cell--right">-</td></tr>;
    $[101] = memberActivity?.committeeDetails.length;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] !== t51 || $[104] !== t52) {
    t53 = <tbody>{t51}{t52}</tbody>;
    $[103] = t51;
    $[104] = t52;
    $[105] = t53;
  } else {
    t53 = $[105];
  }
  let t54;
  if ($[106] !== t50 || $[107] !== t53) {
    t54 = <div className={t41}><table className={t42}>{t50}{t53}</table></div>;
    $[106] = t50;
    $[107] = t53;
    $[108] = t54;
  } else {
    t54 = $[108];
  }
  let t55;
  if ($[109] !== currentCommitteeDetailsTablePage || $[110] !== memberActivity?.committeeDetails?.length || $[111] !== setCurrentCommitteeDetailsTablePage) {
    t55 = Boolean(memberActivity?.committeeDetails?.length && memberActivity?.committeeDetails?.length > 0) && <Pagination className={styles.pagination} initialPage={currentCommitteeDetailsTablePage} onPageChange={index => {
      setCurrentCommitteeDetailsTablePage(index);
    }} totalItemsCount={memberActivity?.committeeDetails?.length} />;
    $[109] = currentCommitteeDetailsTablePage;
    $[110] = memberActivity?.committeeDetails?.length;
    $[111] = setCurrentCommitteeDetailsTablePage;
    $[112] = t55;
  } else {
    t55 = $[112];
  }
  let t56;
  if ($[113] !== t39 || $[114] !== t40 || $[115] !== t54 || $[116] !== t55) {
    t56 = <div className={t39}>{t40}{t54}{t55}</div>;
    $[113] = t39;
    $[114] = t40;
    $[115] = t54;
    $[116] = t55;
    $[117] = t56;
  } else {
    t56 = $[117];
  }
  let t57;
  if ($[118] !== t38 || $[119] !== t56) {
    t57 = <div className={t38}>{t56}</div>;
    $[118] = t38;
    $[119] = t56;
    $[120] = t57;
  } else {
    t57 = $[120];
  }
  return <div className={styles[PARENT_CLASSNAME]}><ContentContainer><div className={styles[`${PARENT_CLASSNAME}__container`]}><div className={styles[`${PARENT_CLASSNAME}__container-item`]}>{t28}<div className={styles["committee-summary"]}>{t29}<div className="table-wrapper"><table className="table">{t34}<tbody><tr>{t35}<td className="cell--right">{memberActivity?.engagementJobsCount ?? "-"}</td><td className="cell--right">{memberActivity?.committeeJobsCount ?? "-"}</td><td className="cell--right">{memberActivity?.leadershipJobsCount ?? "-"}</td></tr><tr>{t36}<td className="cell--right">{memberActivity?.averageEngagementJobsPercentage ?? "-"}</td><td className="cell--right">{memberActivity?.averageCommitteeJobsPercentage ?? "-"}</td><td className="cell--right">{memberActivity?.averageLeadershipJobsPercentage ?? "-"}</td></tr><tr>{t37}<td className="cell--right">{memberActivity?.totalEngagementPoints ?? "-"}</td><td className="cell--right">{memberActivity?.totalCommitteePoints ?? "-"}</td><td className="cell--right">{memberActivity?.totalLeadershipPoints ?? "-"}</td></tr></tbody></table></div></div></div>{t57}</div></ContentContainer></div>;
};
function _temp(item) {
  return <tr key={item.year + item.committee + item.division}><td>{item.year}</td><td>{item.division}</td><td>{item.committee}</td><td>{item.role}</td><td className="cell--right">{item.pointsPossible}</td><td className="cell--right">{item.pointsEarned}</td><td className="cell--right">{item.finalScore}</td></tr>;
}